(function () {
  // The Shopify "quick add"/drawer (product-drawer / quick-view) fetches the
  // product markup and inserts it into the DOM via innerHTML AFTER the
  // initial page load: browsers do NOT execute <script> tags inserted this
  // way, so without the logic below the "Build your bundle" button in that
  // context would stay inert (no listener ever attached). To cover both the
  // "product already on the page at load time" case and the "markup
  // injected later via quick add" case, the init logic below is wrapped in
  // a reusable function (initBundleModal) that runs once immediately and
  // again, on demand, whenever a MutationObserver detects a new bundle
  // modal being added to the DOM.

  // A single modal can now contain MORE THAN ONE .mm-picker (one per kit,
  // when the current product belongs to two kits at once, e.g. the shared
  // Trail Proof trousers / Instant Dry towel). initPicker() sets up one
  // picker in isolation (its own cards/tiers/progress/summary/add-to-cart),
  // and initBundleModal() wires up as many of them as are present, plus the
  // kit-choice step that decides which picker is visible.

  function initPicker(picker) {
    if (!picker || picker.dataset.mmPickerInitialized) return null;
    picker.dataset.mmPickerInitialized = 'true';

    var t = {
      totalLabel: picker.dataset.mmTTotalLabel || 'Total',
      totalNoDiscountLabel: picker.dataset.mmTTotalNoDiscountLabel || 'Total',
      totalDiscountedTemplate: picker.dataset.mmTTotalDiscountedTemplate || 'Discounted total ({pct}%)',
      unlockedTemplate: picker.dataset.mmTUnlockedTemplate || 'You unlocked {pct}% off!',
      addMinSingular: picker.dataset.mmTAddMinSingular || 'Add at least {qty} product for {pct}% off',
      addMinPlural: picker.dataset.mmTAddMinPlural || 'Add at least {qty} products for {pct}% off',
      remainingSingular: picker.dataset.mmTRemainingSingular || '{qty} more product for {pct}% off',
      remainingPlural: picker.dataset.mmTRemainingPlural || '{qty} more products for {pct}% off',
      adding: picker.dataset.mmTAdding || 'Adding to cart...',
      addedSuccess: picker.dataset.mmTAddedSuccess || 'Added to cart!',
      genericError: picker.dataset.mmTGenericError || 'There was an error adding to your cart.'
    };

    function fillTemplate(str, replacements) {
      var out = str;
      for (var key in replacements) {
        out = out.split('{' + key + '}').join(replacements[key]);
      }
      return out;
    }

    var tiers = [
      { qty: parseInt(picker.dataset.mmTier1Qty, 10), pct: parseInt(picker.dataset.mmTier1Pct, 10) },
      { qty: parseInt(picker.dataset.mmTier2Qty, 10), pct: parseInt(picker.dataset.mmTier2Pct, 10) },
      { qty: parseInt(picker.dataset.mmTier3Qty, 10), pct: parseInt(picker.dataset.mmTier3Pct, 10) }
    ].filter(function (tier) { return !isNaN(tier.qty) && tier.qty > 0; })
     .sort(function (a, b) { return a.qty - b.qty; });

    var currencyCode = picker.dataset.mmCurrency || 'EUR';
    var moneyFormatter = null;
    try {
      moneyFormatter = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: currencyCode });
    } catch (e) {
      moneyFormatter = null;
    }
    function formatMoney(cents) {
      var amount = cents / 100;
      return moneyFormatter ? moneyFormatter.format(amount) : (amount.toFixed(2) + ' ' + currencyCode);
    }

    var cards = Array.prototype.slice.call(picker.querySelectorAll('[data-mm-card]'));
    var addBtn = picker.querySelector('[data-mm-add-btn]');
    var feedback = picker.querySelector('[data-mm-feedback]');
    var progressTrack = picker.querySelector('[data-mm-progress-track]');
    var progressLabels = picker.querySelector('[data-mm-progress-labels]');
    var progressStatus = picker.querySelector('[data-mm-progress-status]');
    var summary = picker.querySelector('[data-mm-summary]');
    var summaryLabel = picker.querySelector('[data-mm-summary-label]');
    var summaryOriginal = picker.querySelector('[data-mm-summary-original]');
    var summaryFinalRow = picker.querySelector('[data-mm-summary-final-row]');
    var summaryFinalLabel = picker.querySelector('[data-mm-summary-final-label]');
    var summaryFinal = picker.querySelector('[data-mm-summary-final]');
    var summarySavingsRow = picker.querySelector('[data-mm-summary-savings-row]');
    var summarySavings = picker.querySelector('[data-mm-summary-savings]');

    // Quantita' realmente presenti nel carrello (variant_id -> quantity),
    // ricaricate ad ogni apertura del modal. Serve a evitare di re-inviare a
    // /cart/add.js prodotti gia' aggiunti in una apertura precedente: senza
    // questo, se l'utente torna indietro (es. bfcache) con le checkbox ancora
    // spuntate e ne aggiunge una nuova, il click su "Aggiungi" reinvierebbe
    // anche i prodotti gia' in carrello, facendo scattare eventuali limiti di
    // quantita' massima su quei prodotti e bloccando l'intera richiesta.
    var cartVariantQty = {};

    function getCardVariantId(card) {
      var variantSelect = card.querySelector('[data-mm-variant-select]');
      var variantHidden = card.querySelector('[data-mm-variant-id]');
      return variantSelect ? variantSelect.value : (variantHidden ? variantHidden.value : null);
    }

    function isVariantInCart(variantId) {
      return !!(variantId && cartVariantQty[variantId] > 0);
    }

    function syncCardsWithCart(cartQtyMap) {
      cartVariantQty = cartQtyMap || {};
      cards.forEach(function (card) {
        var variantId = getCardVariantId(card);
        var checkbox = card.querySelector('[data-mm-checkbox]');
        if (isVariantInCart(variantId)) {
          checkbox.checked = true;
          card.setAttribute('data-mm-already-in-cart', 'true');
        } else {
          card.removeAttribute('data-mm-already-in-cart');
        }
      });
    }

    function buildProgressUI() {
      var maxQty = tiers.length ? tiers[tiers.length - 1].qty : 0;
      if (!maxQty || !progressTrack || !progressLabels) return;

      // Mappa quantita' -> fascia, cosi' sappiamo su quale singolo segmento
      // (la "barra" della soglia) va mostrata l'etichetta dello sconto.
      var tierByQty = {};
      tiers.forEach(function (tier) { tierByQty[tier.qty] = tier; });

      for (var i = 0; i < maxQty; i++) {
        var seg = document.createElement('div');
        seg.className = 'mm-picker__progress-segment';
        progressTrack.appendChild(seg);

        // La riga etichette rispecchia esattamente la struttura del track
        // (stesso numero di elementi, stesso flex, stesso gap), cosi' ogni
        // percentuale resta centrata dentro alla propria barra invece che
        // a cavallo tra due barre.
        var unit = document.createElement('div');
        unit.className = 'mm-picker__progress-unit';
        var tier = tierByQty[i + 1];
        if (tier) {
          var label = document.createElement('span');
          label.className = 'mm-picker__progress-label';
          label.setAttribute('data-mm-tier-label', tier.qty);
          label.textContent = '-' + tier.pct + '%';
          unit.appendChild(label);
        }
        progressLabels.appendChild(unit);
      }
    }

    buildProgressUI();

    function selectedCards() {
      return cards.filter(function (c) { return c.querySelector('[data-mm-checkbox]').checked; });
    }

    function selectedCount() {
      return selectedCards().length;
    }

    function subtotalCents() {
      return selectedCards().reduce(function (sum, c) {
        var priceCents = parseInt(c.getAttribute('data-mm-price-cents'), 10);
        return sum + (isNaN(priceCents) ? 0 : priceCents);
      }, 0);
    }

    function currentPct(count) {
      var pct = 0;
      tiers.forEach(function (tier) { if (count >= tier.qty) pct = tier.pct; });
      return pct;
    }

    function currentTierMessage(count) {
      if (tiers.length === 0) return '';
      var maxTier = tiers[tiers.length - 1];
      if (count >= maxTier.qty) {
        return fillTemplate(t.unlockedTemplate, { pct: maxTier.pct });
      }
      for (var i = 0; i < tiers.length; i++) {
        if (count < tiers[i].qty) {
          if (count === 0) {
            var minTemplate = tiers[i].qty === 1 ? t.addMinSingular : t.addMinPlural;
            return fillTemplate(minTemplate, { qty: tiers[i].qty, pct: tiers[i].pct });
          }
          var remaining = tiers[i].qty - count;
          var remainingTemplate = remaining === 1 ? t.remainingSingular : t.remainingPlural;
          return fillTemplate(remainingTemplate, { qty: remaining, pct: tiers[i].pct });
        }
      }
      return '';
    }

    function updateSummary(count, pct) {
      if (!summary) return;
      if (count === 0) {
        summary.hidden = true;
        return;
      }
      summary.hidden = false;
      var subtotal = subtotalCents();

      if (pct > 0) {
        var discounted = Math.round(subtotal * (100 - pct) / 100);
        var savings = subtotal - discounted;
        if (summaryLabel) summaryLabel.textContent = t.totalNoDiscountLabel;
        if (summaryOriginal) {
          summaryOriginal.textContent = formatMoney(subtotal);
          summaryOriginal.classList.add('is-struck');
        }
        if (summaryFinalRow) summaryFinalRow.hidden = false;
        if (summaryFinalLabel) summaryFinalLabel.textContent = fillTemplate(t.totalDiscountedTemplate, { pct: pct });
        if (summaryFinal) summaryFinal.textContent = formatMoney(discounted);
        if (summarySavingsRow) summarySavingsRow.hidden = false;
        if (summarySavings) summarySavings.textContent = formatMoney(savings);
      } else {
        if (summaryLabel) summaryLabel.textContent = t.totalLabel;
        if (summaryOriginal) {
          summaryOriginal.textContent = formatMoney(subtotal);
          summaryOriginal.classList.remove('is-struck');
        }
        if (summaryFinalRow) summaryFinalRow.hidden = true;
        if (summarySavingsRow) summarySavingsRow.hidden = true;
      }
    }

    function updateProgress() {
      var count = selectedCount();

      var segments = progressTrack ? progressTrack.children : [];
      for (var i = 0; i < segments.length; i++) {
        segments[i].classList.toggle('is-filled', i < count);
      }

      if (progressLabels) {
        var labelEls = progressLabels.querySelectorAll('[data-mm-tier-label]');
        labelEls.forEach(function (el) {
          var qty = parseInt(el.getAttribute('data-mm-tier-label'), 10);
          el.classList.toggle('is-active', count >= qty);
        });
      }

      if (progressStatus) progressStatus.textContent = currentTierMessage(count);
      if (addBtn) addBtn.disabled = count === 0;

      cards.forEach(function (c) {
        c.classList.toggle('is-selected', c.querySelector('[data-mm-checkbox]').checked);
      });

      updateSummary(count, currentPct(count));
    }

    cards.forEach(function (card) {
      card.querySelector('[data-mm-checkbox]').addEventListener('change', updateProgress);
      var variantSelect = card.querySelector('[data-mm-variant-select]');
      if (variantSelect) {
        variantSelect.addEventListener('change', function () {
          // Cambiare taglia puo' cambiare il variant_id: ricalcola se questa
          // specifica variante e' gia' presente in carrello.
          if (isVariantInCart(variantSelect.value)) {
            card.setAttribute('data-mm-already-in-cart', 'true');
          } else {
            card.removeAttribute('data-mm-already-in-cart');
          }
        });
      }
    });

    if (addBtn) {
      addBtn.addEventListener('click', function () {
        // Invia solo i prodotti spuntati che NON sono gia' presenti nel
        // carrello: quelli gia' aggiunti in un'apertura precedente del modal
        // vengono esclusi, cosi' non vengono re-inviati a /cart/add.js (evitando
        // di far scattare limiti di quantita' massima su prodotti gia' in
        // carrello e di bloccare l'aggiunta dei prodotti realmente nuovi).
        var items = cards
          .filter(function (c) { return c.querySelector('[data-mm-checkbox]').checked; })
          .map(function (c) { return getCardVariantId(c); })
          .filter(function (id) { return id && !isVariantInCart(id); })
          .map(function (id) { return { id: parseInt(id, 10), quantity: 1 }; });

        if (items.length === 0) {
          // Tutto cio' che e' spuntato e' gia' nel carrello: niente di nuovo da
          // aggiungere, si va direttamente al carrello senza chiamare l'API.
          window.location.href = '/cart';
          return;
        }

        addBtn.disabled = true;
        feedback.textContent = t.adding;
        feedback.className = 'mm-picker__feedback';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then(function (res) {
            if (!res.ok) return res.json().then(function (err) { throw err; });
            return res.json();
          })
          .then(function () {
            feedback.textContent = t.addedSuccess;
            feedback.className = 'mm-picker__feedback is-success';
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            window.location.href = '/cart';
          })
          .catch(function (err) {
            feedback.textContent = (err && err.description) || t.genericError;
            feedback.className = 'mm-picker__feedback is-error';
            addBtn.disabled = false;
          });
      });
    }

    return {
      sync: syncCardsWithCart,
      update: updateProgress
    };
  }

  function initBundleModal(root, modal) {
    if (!modal || modal.dataset.mmInitialized) return;
    modal.dataset.mmInitialized = 'true';

    // The "Build your bundle" button(s) tied to THIS modal instance must be
    // looked up within the same freshly-inserted/present markup (root),
    // before the modal gets re-parented to <body>: after that move the
    // button and the modal would no longer share a common subtree.
    var openBtns = root && root.querySelectorAll ? root.querySelectorAll('[data-mm-bundle-open]') : [];

    // Re-parent the modal to <body>. If left nested inside the product form /
    // sticky buy-box wrapper, an ancestor with a CSS transform (common for
    // sticky columns and sliders) turns `position: fixed` into a position
    // relative to that ancestor instead of the viewport, which breaks the
    // full-screen overlay and can visually cover nearby buttons.
    document.body.appendChild(modal);

    var closeEls = modal.querySelectorAll('[data-mm-bundle-close]');

    // One picker per kit collection (usually 1, but 2 when the current
    // product belongs to two kits at once).
    var pickerEls = Array.prototype.slice.call(modal.querySelectorAll('.mm-picker'));
    var pickers = pickerEls.map(initPicker).filter(Boolean);

    // Kit-choice step: only present when there's more than one picker.
    var chooser = modal.querySelector('[data-mm-kit-chooser]');
    var pickerWraps = Array.prototype.slice.call(modal.querySelectorAll('[data-mm-picker-wrap]'));
    var choiceBtns = Array.prototype.slice.call(modal.querySelectorAll('[data-mm-kit-choice]'));
    var backBtns = Array.prototype.slice.call(modal.querySelectorAll('[data-mm-kit-back]'));

    function showChooser() {
      if (chooser) chooser.hidden = false;
      pickerWraps.forEach(function (wrap) { wrap.hidden = true; });
    }

    function showPicker(index) {
      if (chooser) chooser.hidden = true;
      pickerWraps.forEach(function (wrap) {
        wrap.hidden = wrap.getAttribute('data-mm-picker-index') !== String(index);
      });
    }

    choiceBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        showPicker(btn.getAttribute('data-mm-kit-choice'));
      });
    });

    backBtns.forEach(function (btn) {
      btn.addEventListener('click', function () { showChooser(); });
    });

    function fetchCartState() {
      return fetch('/cart.js')
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          var map = {};
          (cart.items || []).forEach(function (line) {
            map[line.variant_id] = line.quantity;
          });
          return map;
        })
        .catch(function () {
          return {};
        });
    }

    function openModal() {
      modal.hidden = false;
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';

      // Every time the modal is opened, start from the kit-choice step again
      // (if there is one), so a returning shopper is always asked which kit
      // they want before landing on a picker.
      if (chooser) {
        showChooser();
      } else if (pickerWraps.length) {
        showPicker(pickerWraps[0].getAttribute('data-mm-picker-index'));
      }

      fetchCartState().then(function (map) {
        pickers.forEach(function (p) {
          p.sync(map);
          p.update();
        });
      });
    }

    function closeModal() {
      modal.hidden = true;
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    openBtns.forEach(function (btn) { btn.addEventListener('click', openModal); });
    closeEls.forEach(function (el) { el.addEventListener('click', closeModal); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) closeModal();
    });
  }

  function scanAndInit(root) {
    if (!root || !root.querySelectorAll) return;
    var modals = (root.nodeType === 1 && root.matches && root.matches('[data-mm-bundle-modal]'))
      ? [root]
      : Array.prototype.slice.call(root.querySelectorAll('[data-mm-bundle-modal]'));
    modals.forEach(function (modal) { initBundleModal(root, modal); });
  }

  // Instances already present when the page first loads (classic product
  // page rendering).
  scanAndInit(document);

  // Instances injected later (quick add / product drawer). `mutation.target`
  // is the actual parent whose children changed, so it's guaranteed to be a
  // common ancestor of both the "Build your bundle" button and its modal
  // even when they land in the DOM as separate sibling nodes in the same
  // batch of insertions.
  var mmObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.type !== 'childList' || !mutation.addedNodes.length) return;
      for (var i = 0; i < mutation.addedNodes.length; i++) {
        var node = mutation.addedNodes[i];
        if (node.nodeType !== 1) continue;
        if ((node.matches && node.matches('[data-mm-bundle-modal]')) ||
            (node.querySelector && node.querySelector('[data-mm-bundle-modal]'))) {
          scanAndInit(mutation.target);
          break;
        }
      }
    });
  });
  mmObserver.observe(document.documentElement, { childList: true, subtree: true });
})();
